// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"247cb70a","132":"7557e6ea","750":"22b4418d"}[chunkId] + ".css";
};